var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions, } from "@mui/material/useAutocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import highlightWords from "highlight-words";
// Internal
import RenderInput from "./RenderInput";
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing, _b = _a.palette, primary = _b.primary, grey = _b.grey, text = _b.text;
    return ({
        inputSearch: {
            paddingRight: "".concat(spacing(0), " !important"),
        },
        option: {
            padding: spacing(0.5, 1, 0.5, 1),
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            "&.MuiAutocomplete-option": {
                "&:hover": {
                    backgroundColor: grey[500],
                    color: text.primary,
                },
                "&&[aria-selected=true]": {
                    backgroundColor: primary.main,
                    color: primary.contrastText,
                },
            },
        },
        inputFocused: {
            // IE: 11 & Edge: Remove Clearable X
            "&::-ms-clear": {
                display: "none",
            },
        },
        highlightText: {
            fontWeight: "bold",
        },
    });
});
export default (function (_a) {
    var error = _a.error, helperText = _a.helperText, placeholder = _a.placeholder, label = _a.label, required = _a.required, highlight = _a.highlight, _b = _a.loading, loading = _b === void 0 ? false : _b, onChange = _a.onChange, options = _a.options, value = _a.value, inputValue = _a.inputValue, inputSearch = _a.inputSearch, autocompleteParams = __rest(_a, ["error", "helperText", "placeholder", "label", "required", "highlight", "loading", "onChange", "options", "value", "inputValue", "inputSearch"]);
    var renderInput = function (params) { return (React.createElement(RenderInput, { placeholder: value && value.length === 0 ? placeholder : "", label: label, renderInputParams: params, error: error, helperText: helperText, required: required, inputSearch: inputSearch })); };
    var handleChange = function (e, selectedOptions) {
        var cleanedOptions = selectedOptions.reduce(function (cleanArr, currentOption) {
            if (typeof currentOption !== "string") {
                cleanArr.push(currentOption);
            }
            return cleanArr;
        }, []);
        if (onChange)
            onChange(cleanedOptions);
    };
    var filterOptions = createFilterOptions({
        matchFrom: "start",
    });
    var renderOption = function (props, option, state) {
        var chunks = highlightWords({
            text: option.name,
            query: state.inputValue,
        });
        return (React.createElement("li", __assign({}, props), chunks.map(function (chunk) { return (React.createElement("span", { key: chunk.key, className: chunk.match && highlight ? classes.highlightText : undefined }, chunk.text)); })));
    };
    var classes = useStyles();
    return (React.createElement(Autocomplete, __assign({ ChipProps: {
            deleteIcon: React.createElement(FontAwesomeIcon, { icon: faTimes, size: "xs" }),
            size: "small",
        }, clearOnBlur: true, disableClearable: true, disableCloseOnSelect: true, forcePopupIcon: true, freeSolo: true, fullWidth: true, 
        // NOTE freeSolo removes noOptionsText component
        // Workaround: return a custom option and disable it
        filterOptions: function (opts, params) {
            if (opts.length === 0)
                return [{ id: 0, name: "No options" }];
            if (highlight)
                return opts;
            return filterOptions(opts, params);
        }, getOptionDisabled: function (_a) {
            var optionId = _a.id;
            return optionId === 0;
        }, getOptionLabel: function (option) {
            if (typeof option === "string") {
                return option;
            }
            return option.name;
        }, isOptionEqualToValue: function (option, selected) { return option.id === selected.id; }, inputValue: inputValue, loading: loading, multiple: true, onChange: handleChange, options: options, popupIcon: loading ? (React.createElement(CircularProgress, { size: "1.25rem", "aria-label": "loading data", color: "inherit" })) : (React.createElement(ArrowDropDownIcon, null)), renderInput: renderInput, value: value }, (highlight && { renderOption: renderOption }), { classes: __assign(__assign({}, (inputSearch && { inputRoot: classes.inputSearch })), { option: classes.option, inputFocused: classes.inputFocused }) }, autocompleteParams)));
});
//# sourceMappingURL=MultiSelect.js.map